import { Controller } from '@hotwired/stimulus';

// Progressive disclosure for the booking form: reveal the off-studio address block when the merged
// "Studio" dropdown is set to the off-studio option ("Bei dir zu Hause", value `off_studio`).
// Toggles the shared `.hidden` class. The studio field itself is revealed server-side (its
// category-scoped options arrive via Turbo Stream), so this controller no longer touches it.
export default class extends Controller {
  static targets = ['locationSelect', 'address'];

  connect() {
    this.refresh = this.refresh.bind(this);
    this.element.addEventListener('change', this.refresh);
    this.refresh();
  }

  disconnect() {
    this.element.removeEventListener('change', this.refresh);
  }

  // The location dropdown is swapped in by Turbo Stream after connect; re-sync when the new
  // select appears so a pre-selected off-studio value reveals the address block.
  locationSelectTargetConnected() {
    this.refresh();
  }

  refresh() {
    if (!this.hasAddressTarget) return;

    const showAddress = this.hasLocationSelectTarget && this.locationSelectTarget.value === 'off_studio';
    this.addressTarget.classList.toggle('hidden', !showAddress);
  }
}
